import "./presurveypage.css";

import Body from "../Navigation/Body";
import { Button } from "react-bootstrap";
import { ConsentBox } from "./ConsentBox";
import React from "react";
import { UserQuestionnaire } from "./PreSurveyQuestionnaire";
import { useSelector } from "react-redux";

export default function PreSurveyPage() {
  const user_consent = useSelector((state) => state.user.consent);

  // 1) If the user hasn't submitted consent, show the Consent form
  if (!user_consent.submitted) {
    return (
      <Body>
        <ConsentBox />
      </Body>
    );
  }

  // 2) Otherwise, if the user hasn't submitted the presurvey, show that
  return (
    <Body
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      <UserQuestionnaire context="register" />
    </Body>
  );
}
